import { AccrediblePageData } from '@accredible-frontend-v2/models';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { buildInsightsSearchParams } from '../application/insights/insights.helper';
import {
  AUDITABLE_TYPES,
  AuditableType,
  AuditLog,
  AuditLogsBadRequestError,
  AuditLogsFilters,
} from '../entities/insights/audit-logs.model';
import { DashboardApiService } from './db-api.service';

const AUDITABLE_TYPE_PATHS: Record<AuditableType, string> = {
  [AUDITABLE_TYPES.CREDENTIAL]: '',
  [AUDITABLE_TYPES.GROUP]: '',
  [AUDITABLE_TYPES.DESIGN]: '',
  [AUDITABLE_TYPES.GROUP_SKILL_ASSOCIATION]: '/group_skill_associations',
  [AUDITABLE_TYPES.SKILL_FRAMEWORK_ORGANIZATION]: '/skill_framework_organizations',
  [AUDITABLE_TYPES.SKILL_FRAMEWORK_CORPORATION]: '/skill_framework_corporations',
  [AUDITABLE_TYPES.SKILL_FRAMEWORK_CONFIGURATION_ORGANIZATION]:
    '/skill_framework_configuration_organizations',
  [AUDITABLE_TYPES.SKILL_FRAMEWORK_CONFIGURATION_CORPORATION]:
    '/skill_framework_configuration_corporations',
};

@Injectable({
  providedIn: 'root',
})
export class AuditLogsApiService extends DashboardApiService {
  private get _auditsBaseUrl(): string {
    return `/v1/issuer/organizations/${this.embedding.departmentId}/audits`;
  }

  loadAuditLogs(params: AuditLogsFilters): Observable<AccrediblePageData<AuditLog>> {
    const auditPath = AUDITABLE_TYPE_PATHS[params.auditable_type] ?? '';
    const url = `${this._auditsBaseUrl}${auditPath}`;

    return this._get(buildInsightsSearchParams(params, url)).pipe(
      map((res) => this._handleResponse(res)),
      catchError((res: HttpErrorResponse) => {
        if (res.status === 400) {
          return throwError(() => new AuditLogsBadRequestError());
        }

        return this._handleError(res);
      }),
    );
  }
}
